export default {
  'acc103.action.SAVE': '保存',
  'acc103.action.ATTACH': '添付追加',
  'acc103.action.VOID': '取消',
  'acc103.status.CONFIRMED': '計上済',
  'acc103.title': '経費証憑管理',
  'acc103.month': '証憑対象月',
  'acc103.merchant': '取引先・店舗',
  'acc103.receiptDate': '証憑日付',
  'acc103.receiptNumber': '証憑番号',
  'acc103.currency': '原通貨',
  'acc103.grossAmount': '原通貨の税込金額',
  'acc103.taxAmount': '原通貨の税額',
  'acc103.remarks': '備考',
  'acc103.duplicateReason': '重複新規登録の理由',
  'acc103.linkMode': '関連方法',
  'acc103.sourceMonth': '支出・予算対象月',
  'acc103.cashEntryId': '既存の手動支出',
  'acc103.fixedCode': '固定費',
  'acc103.paidDate': '実支払日',
  'acc103.paidJpy': '実支払額（円）',
  'acc103.status': '登録状態',
  'acc103.actions': '操作',
  'acc103.reload': '再読み込み',
  'acc103.new': '証憑追加',
  'acc103.edit': '編集',
  'acc103.view': '表示',
  'acc103.void': '取消',
  'acc103.close': '閉じる',
  'acc103.history': '変更履歴',
  'acc103.actor': '操作者',
  'acc103.saveDraft': '下書き保存',
  'acc103.saveLink': '保存して関連付け',
  'acc103.saved': '保存しました',
  'acc103.openOriginal': '元の証憑グループを開く',
  'acc103.camera': '写真を撮る',
  'acc103.upload': '写真・ファイル',
  'acc103.fileHint':
    'JPEG / PNG / WebP / PDF、1ファイル10MB以内、PDF10ページ以内。1グループ1証憑、添付追加で支出を重複計上しません。',
  'acc103.preview': '原件プレビュー',
  'acc103.previewFailed': '原件を読み込めません。添付を再選択してください。',
  'acc103.noFile': '原件を選択・アップロード',
  'acc103.aiNotice':
    '選択した原件をMiniMax中国サイトへ送信します。結果は人が確認し、AIは自動計上しません。続行しますか？',
  'acc103.aiDisabled':
    'AI未設定または実画像テスト未完了です。手入力・下書き保存・関連付けは利用できます。',
  'acc103.recognize': 'AI読取・再試行',
  'acc103.pages': '処理済ページ',
  'acc103.applyWarning': '読取項目を反映しますか？金額・日付・複数税率を確認してください。',
  'acc103.apply': '読取結果を反映',
  'acc103.stale': '下書きまたは入力が変更されました。保存後に再読取し、手修正を保護してください。',
  'acc103.currencyHint': 'JPY、USDなど大文字3桁の通貨コードを入力してください。',
  'acc103.duplicateHint':
    '重複時は元グループに追加してください。新規登録が必要な場合は理由を記入してください。',
  'acc103.link': '支出との関連',
  'acc103.budget': '既存予算',
  'acc103.difference': '証憑実額と予算の差額',
  'acc103.budgetHint': '証憑の関連・差額表示のみ。予算を置換せず、追加計上しません。',
  'acc103.syncPayment': '元支出の支払日・金額も更新する（損益・現金予測へ反映）',
  'acc103.linkedPayment': '関連支出の現在値',
  'acc103.paymentHint':
    '新規支出には実支払日・円実払額が必要です。不明時は下書き保存。原通貨の税額は証憑情報のみです。',
  'acc103.voidWarning': '証憑のみ取り消しますか？元の支出・支払は取り消しません。',
  'acc103.mode.NEW': '新規支出',
  'acc103.mode.EXISTING': '既存手動支出に関連',
  'acc103.mode.FIXED': '固定予算に関連',
  'acc103.status.DRAFT': '下書き',
  'acc103.status.REGISTERED': '登録済',
  'acc103.status.VOID': '取消済',
  'acc103.status.QUEUED': '待機中',
  'acc103.status.RUNNING': '読取中',
  'acc103.status.SUCCEEDED': '読取完了',
  'acc103.status.FAILED': '読取失敗',
  'acc103.error.FAILED': '処理できませんでした。入力は保持されています。確認後再試行してください。',
  'acc103.error.INVALID': '入力・日付・金額を確認してください。',
  'acc103.error.CONFLICT': '他で更新されました。開き直して最新内容を確認してください。',
  'acc103.error.DUPLICATE':
    'ファイルまたは証憑の重複候補です。元グループを開くか、新規理由を記入してください。',
  'acc103.error.NOT_FOUND': '対象がないか参照できません。',
  'acc103.error.REGISTER_REQUIRED': '登録済証憑は「保存して関連付け」を使用してください。',
  'acc103.error.PAYMENT_REQUIRED': '実支払日と円実払額を入力するか、下書き保存してください。',
  'acc103.error.SYNC_REQUIRED': '支払情報を確認し、元支出の更新に同意してください。',
  'acc103.error.PAYMENT_INVALID': '支払日・金額・バージョンを確認してください。',
  'acc103.error.FILE_LIMIT': '空でない10MB以内のファイルを選択してください。',
  'acc103.error.FILE_TYPE': 'JPEG・PNG・WebP・PDFの有効なファイルではありません。',
  'acc103.error.PDF_LIMIT': '暗号化されていない10ページ以内のPDFが必要です。',
  'acc103.error.IMAGE_LIMIT': '画像が大きすぎます。縮小して再送してください。',
  'acc103.error.ATTACHMENT_LIMIT': '1グループ添付10件・合計20ページまでです。',
  'acc103.error.AI_DISABLED': 'AIは無効です。手入力するか管理者に実画像テストを依頼してください。',
  'acc103.error.CONSENT_REQUIRED': '送信前の明示的な同意が必要です。',
  'acc103.error.AI_LIMIT': '契約枠またはレート制限です。後で手動再試行してください。',
  'acc103.error.AI_ACCESS': '契約キーの権限を管理者に確認してください。',
  'acc103.error.AI_TIMEOUT':
    '読取タイムアウトまたは通信障害です。原件を保持しました。手動再試行できます。',
  'acc103.error.AI_FAILED':
    '読取に失敗しました。原件を保持しました。手入力または再試行してください。',
  'acc103.error.AI_INVALID': '結果が不正または不完全です。人が確認して再試行してください。',
  'acc103.error.INTERRUPTED':
    '前回の読取が中断されました。自動再送していません。確認後再試行してください。',
  'acc103.expenseName': '費用名',
  'menu.accounting.expense-invoices': '経費証憑管理',
};
